export default __webpack_public_path__ + "static/media/yes_select.47aebb70.svg";